import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "register-box" }
const _hoisted_2 = { class: "card card-outline card-primary" }
const _hoisted_3 = { class: "card-header text-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Admin", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("LTE")
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "login-box-msg" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-7" }
const _hoisted_10 = { href: "#" }
const _hoisted_11 = { class: "col-5" }
const _hoisted_12 = { class: "social-auth-links text-center" }

export function render(_ctx, _cache) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_checkbox = _resolveComponent("app-checkbox")
  const _component_app_button = _resolveComponent("app-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "h1"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("labels.registerMembership")), 1),
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => (_ctx.registerByAuth && _ctx.registerByAuth(...args)), ["prevent"]))
        }, [
          _createVNode(_component_app_input, {
            icon: "envelope",
            class: "mb-3",
            type: "email",
            placeholder: "Email",
            autocomplete: "off",
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.email) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_app_input, {
            icon: "lock",
            class: "mb-3",
            type: "password",
            placeholder: "Password",
            autocomplete: "off",
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.password) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_app_input, {
            icon: "lock",
            class: "mb-3",
            type: "password",
            placeholder: "Retype password",
            autocomplete: "off",
            modelValue: _ctx.rePassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.rePassword) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_app_checkbox, {
                type: "icheck",
                modelValue: _ctx.agreeTerms,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.agreeTerms) = $event))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("labels.iAgree")) + " ", 1),
                  _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t("labels.terms")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_app_button, {
                class: "btn-primary",
                type: "submit",
                block: "true",
                loading: _ctx.isAuthLoading,
                disabled: _ctx.isFacebookLoading || _ctx.isGoogleLoading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("labels.register")), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ])
          ])
        ], 32),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_app_button, {
            class: "btn-primary",
            icon: "facebook",
            block: "true",
            onClick: _ctx.registerByFacebook,
            loading: _ctx.isFacebookLoading,
            disabled: _ctx.isAuthLoading || _ctx.isGoogleLoading
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("labels.signUpUsingFB")), 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"]),
          _createVNode(_component_app_button, {
            class: "btn-danger",
            icon: "google-plus",
            block: "true",
            onClick: _ctx.registerByGoogle,
            loading: _ctx.isGoogleLoading,
            disabled: _ctx.isAuthLoading || _ctx.isFacebookLoading
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("labels.signUpUsingGoogle")), 1)
            ]),
            _: 1
          }, 8, ["onClick", "loading", "disabled"])
        ]),
        _createVNode(_component_router_link, {
          to: "/login",
          class: "text-center"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("labels.alreadyHaveMembership")), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}